import React from "react";
import { ActivationCodes } from "./activation-codes";

export const TestActivationCodes: React.FC = () => {
  return (
    <div className="p-8 bg-background min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8">Test Activation Codes Component</h1>
        <ActivationCodes />
      </div>
    </div>
  );
};

export default TestActivationCodes;